import React from 'react';

import cx from 'classnames';

import './index.scss';

export interface IListProps extends React.HTMLAttributes<HTMLDivElement> {
  items?: React.ReactNode[];
  itemsClassName?: string;
  itemsPadding?: string;
  itemsMargin?: string;
  ordered?: boolean;
  letters?: boolean;
}

const List: React.FC<IListProps> = ({
  className,
  ordered = false,
  letters = false,
  itemsPadding = 'pl-5',
  itemsClassName,
  items = [],
}) => {
  const Component = ordered ? 'ol' : 'ul';

  return (
    <Component className={cx('List my-4', ordered && letters && 'List--alpha', className)}>
      {items.map((item, key) => (
        <li key={key} className={cx('leading-loose', itemsPadding, itemsClassName)}>
          {item}
        </li>
      ))}
    </Component>
  );
};

export default List;
